import env from '@/env';

function app(params) {
  return env.BABELPRO_DOMAIN + '/mall/active/' + params + '/index.html' + env.BABELPRO_PARAMS;
}

function pc(params) {
  return env.BABELPRO_PC_DOMAIN + '/mall/active/' + params + '/index.html' + env.BABELPRO_PARAMS;
}

function wq(params) {
  return env.BABELPRO_DOMAIN + '/wq/active/' + params + '/index.html' + env.BABELPRO_PARAMS;
}

function mini(params) {
  return env.BABELPRO_DOMAIN + '/mini/active/' + params + '/index.html' + env.BABELPRO_PARAMS + '&wxAppName=jd';
}

export const links = {
  app,
  pc,
  wq,
  mini,
};
